import { render } from "./ShareFarm.vue?vue&type=template&id=e80610d8&scoped=true"
import script from "./ShareFarm.vue?vue&type=script&lang=js"
export * from "./ShareFarm.vue?vue&type=script&lang=js"

import "./ShareFarm.vue?vue&type=style&index=0&id=e80610d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80610d8"]])

export default __exports__